import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Stack,
    Grid
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';

export default function AddFamilyMemberDialog({ open, onClose, onCreate }) {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState(null);
    const [socialNumber, setSocialNumber] = useState("");

    const handleCreate = () => {
        const newMember = {
            firstName,
            lastName,
            socialNumber,
            dateOfBirth: dateOfBirth ? dateOfBirth.format("DD-MM-YYYY") : null,
        };
        onCreate(newMember);
        setFirstName("");
        setLastName("");
        setDateOfBirth(null);
    };

    const handleCancel = () => {
        onClose();
        setFirstName("");
        setLastName("");
        setDateOfBirth(null);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Familienmitglied hinzufügen</DialogTitle>
            <DialogContent>
                <Stack spacing={2} mt={1}>
                    <TextField
                        label="Vorname"
                        variant="standard"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label="Nachname"
                        variant="standard"
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        label="Sozialversicherungsnummer"
                        variant="standard"
                        value={socialNumber}
                        onChange={(e) => setSocialNumber(e.target.value)}
                        fullWidth
                    />
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            label="Geburtsdatum"
                            value={dateOfBirth}
                            format="DD-MM-YYYY"
                            onChange={(newValue) => setDateOfBirth(newValue)}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    variant: "standard"
                                },
                            }}
                        />
                    </LocalizationProvider>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ width: '100%', marginLeft: '15px', marginRight: '15px', marginBottom: '5px'}}>
                    <Button
                        variant="contained"
                        color="success"
                        startIcon={<CheckIcon />}
                        onClick={handleCreate}
                    >
                        Erstellen
                    </Button>

                    <Button
                        variant="outlined"
                        startIcon={<CancelIcon />}
                        onClick={handleCancel}
                    >
                        Stornieren
                    </Button>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}